import { Component, OnInit } from '@angular/core';
import { CmsmoduleService } from '../../manage/cmsmodule/service/cmsmodule.service';
import { BannerService } from '../../services/banner.service';
import { MenuItem } from 'primeng/api';
@Component({
  selector: 'app-club-leagues',
  templateUrl: './clubleagues.component.html',
  styleUrls: ['./clubleagues.component.scss']
})
export class ClubLeaguesComponent implements OnInit {
  items:MenuItem[];
  public loading: boolean;
  public cmsContent;
  public cmsContentData;
  public errorMessage: string;
  public bannerList: any[];
  public totalRecords = 0;
  public bannerImageList: any[] = [];
  carouselResponsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 12,
      numScroll: 12,
      margin: 20,
    },
    {
      breakpoint: '768px',
      numVisible: 2,
      numScroll: 2,
      margin: 20,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      numScroll: 1
    }
  ];

  constructor(private cmsmoduleService: CmsmoduleService, private bannerService: BannerService) { }

  ngOnInit(): void {
    this.getCmsContent();
    this.getBanner();
    this.items=[
      {routerLink:"/", label:"Home" },
      {label:"Club Leagues"}
    ]
  }

  getCmsContent() {
    var query = "?filterByDisable=false&filterByStatus=true&filterBySlug=clubleagues";
    this.cmsmoduleService.getContentDetails(query).subscribe(
      data => {
        this.loading = false;
        this.cmsContent = data.data.items[0];
        if (this.cmsContent != undefined) {
          this.cmsContentData = this.cmsContent['cmsDescription'];
        }
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }


  getBanner() {
    let query = "?filterByDisable=false&filterByStatus=true&filterBySlug=clubleagues";
    this.bannerService.getbannerList(query).subscribe(
      data => {
        this.loading = false;
        this.bannerList = data.data.items;
        this.totalRecords = data.data.totalCount;
        this.bannerList.forEach(element => {
          this.bannerImageList = element.banner_image;
        });
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }
}
